export const FETCH_ONE = 'posts/FETCH_ONE';
export const FETCH_ONE_SUCCESS = 'posts/FETCH_ONE_SUCCESS';
export const FETCH_COLLECTION = 'posts/FETCH_COLLECTION';
export const FETCH_COLLECTION_SUCCESS = 'posts/FETCH_COLLECTION_SUCCESS';
export const CREATE = 'posts/CREATE_POST';
export const CREATE_SUCCESS = 'posts/CREATE_POST_SUCCESS';
export const CREATE_FAILED = 'posts/CREATE_FAILED';
export const UPDATE = 'posts/UPDATE';
export const UPDATE_SUCCESS = 'posts/UPDATE_SUCCESS';
export const DELETE = 'posts/DELETE';
export const DELETE_SUCCESS = 'posts/DELETE_SUCCESS';
export const POST_ACTION_TOGGLE_LOADING = "posts/POST_ACTION_TOGGLE_LOADING";
export const GET_POSTS_SIGNED_URL = 'posts/GET_POSTS_SIGNED_URL';
export const GET_POSTS_SIGNED_URL_SUCCESS = 'posts/GET_POSTS_SIGNED_URL_SUCCESS';
export const FETCH_POSTS_BY_SIGNED_URL = 'posts/FETCH_POSTS_BY_SIGNED_URL';
export const FETCH_POSTS_BY_SIGNED_URL_SUCCESS = 'posts/FETCH_POSTS_BY_SIGNED_URL_SUCCESS';